module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-23-ff952da0b1904ec9af6340c488f726b9.jpg";